import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
	selector: '[dataLayer-host]',
})

export class DataLayerDirective {
	constructor(public viewContainerRef: ViewContainerRef ) {}
}
